import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import Title from "../../components/common/Title";
import { ValidationAlert } from "../../components/common/ValidationAlert";
import Layout from "../../components/layout/Layout";
import TopBarGridContainer from "../../components/layout/TopBar";
import { uploadCollectionData } from "../../utils/data_uploader";
import FileInput from "./components/FileInput";
import { ALERT_MESSAGES, ALERT_TYPES } from "./constants/alertConstants";

import useAlert from "../../hooks/useAlert";

function DataUploader() {
  const [file, setFile] = useState(null);
  const [platformType, setPlatformType] = useState("Manual Collection");
  const { alertState, showAlert, closeAlert } = useAlert();

  /** Handles file upload process and updates alert state based on the response*/
  const handleUploadFile = async () => {
    // Validate file existence
    if (!file) {
      showAlert(ALERT_TYPES.ERROR, ALERT_MESSAGES.NO_FILE);
      return;
    }

    // Prepare form data
    const data = new FormData();
    data.append(platformType, file);

    // Upload file and get response
    const uploadRes = await uploadCollectionData(data);
    const uploadResJson = await uploadRes.json();
    const successMsg = Object.values(uploadResJson.msg).join("\n");

    // Set alert based on response
    showAlert(
      uploadRes.status === 400 ? ALERT_TYPES.ERROR : ALERT_TYPES.SUCCESS,
      uploadRes.status === 400 ? uploadResJson.error : ALERT_MESSAGES.UPLOAD_SUCCESS(successMsg)
    );
  };

  const handlePlatformChange = (event) => setPlatformType(event.target.value);

  return (
    <Layout>
      <ValidationAlert
        inputOpen={alertState.alertOpen}
        setInputClosed={closeAlert}
        severity={alertState.alertType}
        alertMessage={alertState.alertMsg}
      />

      <TopBarGridContainer>
        <Grid size="grow">
          <Title text="Data Uploader" sx={{ my: 5 }} />
        </Grid>
      </TopBarGridContainer>

      <Grid container direction="column" alignItems="center" justifyContent="center" mt={5}>
        <Grid size={4} mb={5}>
          <FileInput file={file} setFile={setFile} />
        </Grid>
        <Grid size={4} mb={5}>
          <FormControl>
            <FormLabel id="platform-type-group-label">Platform Type</FormLabel>
            <RadioGroup
              row
              aria-labelledby="platform-type-group-label"
              name="radio-buttons-group"
              value={platformType}
              onChange={handlePlatformChange}
            >
              <FormControlLabel value="Manual Collection" control={<Radio />} label="Manual Collection" />
              <FormControlLabel value="Linkedin" control={<Radio />} label="Linkedin" />
              <FormControlLabel value="Manual Collection China" control={<Radio />} label="Manual Collection China" />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid size="grow">
          <Button
            variant="outlined"
            color="primary"
            startIcon={<FileUploadIcon />}
            sx={{ py: 1, ml: 1 }}
            onClick={handleUploadFile}
          >
            Upload File
          </Button>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default DataUploader;
